import { createPinia } from 'pinia';
export const pinia = createPinia();
// Exportar instancia de Pinia para usar en main.ts
export default pinia;
